import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface PanelFooterProps {
  /** Footer content — typically primary/secondary action buttons. */
  children: ReactNode;
  /**
   * Top hairline separating the footer from the pane body.
   * Defaults to true; set false when spacing alone is enough.
   */
  divider?: boolean;
}

/**
 * Footer for a self-contained content pane: actions row pinned below the body,
 * optional top hairline. Place via Panel's `footer` prop, or as the last child
 * of a flex column body (uses `mt: auto` to stick to the bottom).
 */
export function PanelFooter({ children, divider = true }: PanelFooterProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flexShrink: 0,
        mt: 'auto',
        pb: 1.5,
        ...(divider
          ? {
              pt: 1.5,
              borderTop: '0.5px solid',
              borderColor: 'divider',
            }
          : { pt: 1 }),
      }}
    >
      {children}
    </Box>
  );
}
